export default __webpack_public_path__ + "static/media/pendientesS.887fd82b.png";